<ion-col class="text-block mx-4" *ngIf="!showMap" >
  <h2 class="mb-4">{{isSetup ? 'Legg til din første adresse' : 'Legg til en adresse'}}</h2>  
  <p>
    Smartlading vil bare være tilgjengelig på adresser som er lagt til av
    deg, for å unngå å forstyrre med offentlige ladere.
  </p>
  <p>Adresser knyttet til din konto</p>
  <p *ngIf="noLocationFound">
    Fant ingen adresser. Velg en adresse fra kartet
  </p>
  <div *ngFor="let location of locationSuggestions">
    <div
      class="locationActions location-container"
      [class.selected-row]="
        locationChosen && location.name === chosenLocation.name
      "
    >
      <ion-icon class="location-icon" name="location"></ion-icon>
      <p class="m-0 location-name">
        <strong>{{ location.name }}</strong>
      </p>
      <ion-button
        class="choice-button radius-full"
        [class.green]="
          locationChosen && location.name === chosenLocation.name
        "
        (click)="pickLocation(location)"
        >{{
          locationChosen && location.name === chosenLocation.name
            ? 'Valgt'
            : 'Velg'
        }}</ion-button
      >
    </div>
  </div>
  <ion-button (click)="openMap()"  [class.mb-8]="isModal">{{
    noLocationFound ? 'Finn en adresse i kartet' : 'Finn en annen adresse'
  }}</ion-button>
  @if (isSetup) {
    <p>Du kan alltids legge til flere adresser på et senere tidspunkt.</p>
  }

  <div *ngIf="noLocationChosen" class="error-block">
    <ion-icon class="error-icon" name="close-circle-outline"></ion-icon>
    <p>
      Du må velge en adresse før du kan gå videre
    </p>
  </div>
</ion-col>

<ion-col *ngIf="showMap">
  <app-location-picker
    [locationSuggestions]="locationSuggestions"
    (emitCloseMap)="showMap = false"
    (emitSelectedLocation)="setSelectedLocation($event)"
  ></app-location-picker>
</ion-col>

@if (locationChosen) {
  <div class="form-input-ihk mt-8">
    <p>
      Sett et navn for adressen slik at du lett kan kjenne den igjen
      senere. For eksempel Hjem eller Jobb.
    </p>
    <p>
      Kallenavn for <strong>{{ friendlyLocationName }}</strong>
    </p>
    <ion-input
      label="Navn på adressen"
      placeholder="Navn på adressen"
      fill="outline"
      labelPlacement="stacked"
      [(ngModel)]="locationName"
    ></ion-input>
  </div>
}
<div *ngIf="hasPostLocationError || hasPostTariffError" class="error-block">
  <ion-icon class="error-icon" name="close-circle-outline"></ion-icon>
  <p class="">
    Det oppsto en feil ved lagring av adresse. Vennligst prøv igjen.
    Om problemet vedvarer, vennligst kontakt oss.
  </p>
</div>

<ion-row class="mt-4" *ngIf="!showMap">
  <ion-col class="button-container">
    <ion-button (click)="back()">Tilbake</ion-button>
    <ion-button
      (click)="postLocation()"
      class="dark">Lagre</ion-button>
  </ion-col>
</ion-row>